// /src/components/ServiciosSII.js
import { useNavigate } from 'react-router-dom';
import { FaFileInvoiceDollar, FaGavel, FaFileSignature } from 'react-icons/fa';
import '../styles/pages/ServiciosSII.css';


const ServiciosSII = ({ id_company }) => {
    const navigate = useNavigate();

    // Opciones de servicios disponibles
    const servicios = [
        { nombre: "Declaración de IVA", ruta: "/declaracion-iva", icon: <FaFileInvoiceDollar /> },
        { nombre: "Declaraciones Juradas", ruta: "/declaraciones-juradas", icon: <FaGavel /> },
        { nombre: "Declaración de Renta", ruta: "/declaracion-renta", icon: <FaFileSignature /> }
    ];

    const handleServicioClick = (ruta) => {
        navigate(ruta, { state: { id_company } });
    };

    return (
        <div className="servicios-page">
            <header className="servicios-header">
                <h1 className="servicios-title">Impuestos</h1>
                <p className="servicios-sub">Gestión de declaraciones ante el SII</p>
            </header>
            <div className="servicios-grid">
                {servicios.map((servicio, index) => (
                    <div
                        key={index}
                        className="service-box"
                        role="button"
                        tabIndex={0}
                        onClick={() => handleServicioClick(servicio.ruta)}
                        onKeyDown={(e) => e.key === 'Enter' && handleServicioClick(servicio.ruta)}
                    >
                        <span className="service-box-icon">{servicio.icon}</span>
                        <span className="service-box-label">{servicio.nombre}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ServiciosSII;
